var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","height":"65","color":"transparent","absolute":_vm.absolute}},[_c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }